import SendIcon from '@common/components/Icons/SendIcon';
import React, { Fragment, useMemo } from 'react';
import { StyleSheet, TextInput, TouchableOpacity, View } from 'react-native';
import { useChatComponentContext } from '../context';
import { useChatComponent } from '../hook';
import { useAutoGrowInput } from '../../../ChatComponent/useAutoGrowInput';
import {
  FILE_UPLOADING,
  INPUT_BORDER_WIDTH,
  INPUT_LINE_HEIGHT,
  INPUT_PADDING_VERTICAL,
  MAX_INPUT_LENGTH,
} from '../../../ChatComponent/utils';
import { CusImagePicker } from './CusImagePicker';
import { FileList } from './FileList';

export const InputMessage = () => {
  const {
    filesValue,
    inputValue,
    setInputValue,
    inputLines,
    setInputLines,
    messageHistoryLoading,
    messageSending,
    fileUploading,
    props,
  } = useChatComponentContext();
  const { sendMessage } = useChatComponent(props);
  const { inputRef, heightStyle } = useAutoGrowInput({
    value: inputValue,
    lines: inputLines,
    width: props.style?.width ?? props.width,
    onLinesChange: setInputLines,
  });

  const files = useMemo(() => {
    if (fileUploading) {
      return [...(filesValue || []), FILE_UPLOADING];
    }
    return filesValue;
  }, [fileUploading, filesValue]);

  return (
    <View style={styles.container}>
      {files?.length ? (
        <View style={styles.fileListContainer}>
          <FileList files={files} showRemoveFile />
        </View>
      ) : (
        <Fragment />
      )}
      <View style={styles.inputContainer}>
        <TextInput
          ref={inputRef}
          style={[styles.textInputContainer, heightStyle]}
          placeholder="メッセージを入力"
          onChangeText={(e) => setInputValue?.(e)}
          value={inputValue}
          multiline
          maxLength={MAX_INPUT_LENGTH}
        />
        <View style={styles.buttonGroup}>
          <CusImagePicker />
          <TouchableOpacity
            style={styles.sendButton}
            onPress={sendMessage}
            disabled={messageHistoryLoading || messageSending}
          >
            <SendIcon />
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    bottom: 0,
    width: '100%',
    minHeight: 57,
    paddingHorizontal: 20,
    paddingVertical: 8,
    backgroundColor: 'white',
    borderTopWidth: 1,
    borderTopColor: '#F0F0F0',
    alignItems: 'flex-start',
    shadowColor: '#164F78',
    shadowOffset: { width: 0, height: -34 },
    shadowOpacity: 0.03,
    shadowRadius: 30,
  },
  fileListContainer: {
    minHeight: 70,
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'flex-end',
    marginTop: 4,
  },
  textInputContainer: {
    flex: 1,
    paddingHorizontal: 14,
    paddingVertical: INPUT_PADDING_VERTICAL,
    backgroundColor: 'white',
    borderRadius: 4,
    borderWidth: INPUT_BORDER_WIDTH,
    borderColor: '#E9EFF2',
    color: 'black',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: 14,
    fontWeight: '400',
    lineHeight: INPUT_LINE_HEIGHT,
    // Native cap. On web useAutoGrowInput raises this to INPUT_MAX_HEIGHT and
    // pins an explicit height, because a <textarea> never grows on its own.
    maxHeight: 120,
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 12,
  },
  sendButton: {
    marginLeft: 8,
  },
});
